export default "__VITE_ASSET__CfezRXDx__"